<p-table [value]="rules">
  <ng-template pTemplate="header">
      <tr>
          <th>Module</th>
          <th>Channel</th>
          <th>Type</th>
          <th>Default Selected</th>
          <th>Preferred Selected</th>
          <th>Action</th>
          <th style="width: 2rem;">
              <span class="btnBars p-mr-0" (click)="addRule()">
                  <i class="pi pi-plus"></i>
              </span>
          </th>
      </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rule>
      <tr>
          <td>{{rule.moduleName}}</td>
          <td>{{rule.channel}}</td>
          <td>{{rule.type?.name}}</td>
          <td>{{rule.defaultSelected}}
          </td>
          <td>{{rule.preferredDefault}}</td>
          <td>
            <span class="btnBars p-mr-0">
              <i class="pi pi-pencil" (click)="getRulebyId(rule.id)"></i>
            </span>
            <span class="btnBars p-mr-0">
              <i class="pi pi-microsoft" (click)="loadAPIDataByType(rule.moduleName,rule.type?.name,rule.channelId)"></i>
            </span>
          </td>
          <td></td>
      </tr>
  </ng-template>
</p-table>


<p-dialog header="{{addEditRule}}" [(visible)]="displayAddRule" [modal]="true" [responsive]="true"
[style]="{width: '60vw'}" (onHide)="customRuleForm.reset()">
 <form [formGroup]="customRuleForm">
  <div class="card">
    <div class="p-grid">
      <div class="p-col-12 p-md-6">
        <label>Module<span style="color:red;">*</span></label>
        <p-dropdown [options]="allModules" optionLabel="name" placeholder="Select Module" appendTo="body" 
          formControlName="moduleId" [disabled]="!isAdd" (onChange)="loadConfigurations()"></p-dropdown>
      </div>
      <div class="p-col-12 p-md-6">
        <label>Channel<span style="color:red;">*</span></label>
        <p-dropdown [disabled]="!isAdd" [options]="allChannels" [disabled]="disabledChannel" optionLabel="name" placeholder="Select Channel" appendTo="body" 
         formControlName="channelId"></p-dropdown>
      </div>
    </div>
    <div class="p-grid">
      <div class="p-col-12 p-md-6">
        <label>Type<span style="color:red;">*</span></label>
        <p-dropdown [disabled]="!isAdd" [options]="ruleTypes" optionLabel="name" formControlName="typeId" placeholder="Select Type" appendTo="body" 
          (onChange)="loadAPIs()"></p-dropdown>
      </div>
      <div class="p-col-12 p-md-6">
        <label>Default Selected<span style="color:red;">*</span></label>
        <p-multiSelect [options]="customRuleForm.controls['typeId']?.value?.name=='Payment Term'?allPaymentTermsDD:allPaymentMethodsDD" formControlName="defaultSelected" optionLabel="name" 
          defaultLabel="Select Default {{customRuleForm.controls['typeId']?.value?.name}}" appendTo="body"
           (onChange)="setValue($event)"></p-multiSelect>
      </div>
    </div>
    <div class="p-grid">
      <div class="p-col-12 p-md-6">
        <label>Preferred Selected<span style="color:red;">*</span></label>
        <p-dropdown [options]="customRuleForm.controls['defaultSelected']?.value" optionLabel="name" placeholder="Select Preferred {{selectedType?.name}}" 
        appendTo="body" formControlName="preferredDefault" optionDisabled="inactive"></p-dropdown>
      </div>
    </div>
    <div class="p-grid">
      <div class="p-col-12">
        <label>Option</label>
         <div *ngFor="let opt of ruleOptions;let i=index;">
          <div class="p-field-radiobutton p-m-0">
            <p-radioButton [name]="ruleApplyTypeId" [value]="opt.id" formControlName="ruleApplyTypeId" inputId="option{{i}}"></p-radioButton>
            <label for="option{{i}}">{{opt.name}}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
 </form>
<p-footer>
  <button type="button" pButton (click)="displayAddRule=false" label="Cancel"
    class="p-button-secondary"></button>
  <button type="button" pButton label="Save" [disabled]="!customRuleForm.valid || isDisabled" (click)="validateCustomRuleCombination(customRuleForm.value)"></button>
</p-footer>
</p-dialog>

<!-- For Vendors -->
<p-dialog [(visible)]="displayVendorTB" [modal]="true" [responsive]="true" [style]="{width: '80vw'}" [closable]="false">
  <div class="card">
      <p-table #dt [value]="vendorsData"
       [paginator]="true" [totalRecords]="totalRecords" [lazy]="true" [rows]="pageSize" [showCurrentPageReport]="true"
       currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" (onPage)="getData($event)"
        [first]=first>
          <ng-template pTemplate="caption">
              <div class="p-d-flex p-jc-between">
                  <div style="width: 30%;">
                      <input pInputText type="text" (ngModelChange)="changed($event,'vendor')" [(ngModel)]="searchValue" placeholder="Search..." />
                  </div>
              </div>
          </ng-template>
          <ng-template pTemplate="header">
              <tr>
                  <th>Vendor Name</th>
                  <th>Street</th>
                  <th>City</th>
                  <th>State</th>
                  <th>{{headerType}}</th>
                  <th>Prefered Selected</th>
                  <th class="action" style="width: 2rem;">
                      <span class="btnBars p-mr-0">
                          <i class="pi pi-pencil" (click)="isEdit = !isEdit"></i>
                      </span>
                  </th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-vendor let-rowIndex="rowIndex">
              <tr>
                  <td>{{vendor.name}}</td>
                  <td>{{vendor.street}}</td>
                  <td>{{vendor.city}}</td>
                  <td>{{vendor.state}}</td>
                  <ng-container *ngIf="isPaymentTerm">
                      <td *ngIf="!isEdit">
                          <ng-container *ngFor="let s of vendor.defaultPaymentTerms; let i = index;">
                              <span>{{s.name}}</span>
                              <span *ngIf="vendor.defaultPaymentTerms.length > 1 && i !== vendor.defaultPaymentTerms.length-1">,</span>
                          </ng-container>
                      </td>
                      <td *ngIf="isEdit" class="action">
                          <p-multiSelect [options]="vendor.paymentTerms" [(ngModel)]="vendor.defaultPaymentTerms" 
                          optionLabel="name" appendTo="body"  placeholder="Select Default" (onChange)="onChangeCustomRule(vendor)"></p-multiSelect>
                      </td>
                      <td *ngIf="!isEdit">
                            {{vendor.preferredPaymentName}}
                      </td>
                      <td *ngIf="isEdit" class="action">
                          <p-dropdown [options]="vendor.defaultPaymentTerms" optionLabel="name" appendTo="body" optionDisabled="inactive"
                          [(ngModel)]="vendor.preferredPayment" placeholder="Select Preferred" (onChange)="onChangeCustomRule(vendor)" optionValue="id"></p-dropdown>
                      </td>
                  </ng-container>
                  <ng-container *ngIf="isPaymentMethod">
                      <td *ngIf="!isEdit">
                          <ng-container *ngFor="let s of vendor.defaultPaymentMethods; let i = index;">
                              <span>{{s.name}}</span>
                              <span *ngIf="vendor.defaultPaymentMethods.length > 1 && i !== vendor.defaultPaymentMethods.length-1">,</span>
                          </ng-container>
                      </td>
                      <td *ngIf="isEdit" class="action">
                          <p-multiSelect [options]="vendor.paymentMethods" [(ngModel)]="vendor.defaultPaymentMethods" 
                          optionLabel="name" placeholder="Select Default" appendTo="body" (onChange)="onChangeCustomRule(vendor)"></p-multiSelect>
                      </td>
                      <td *ngIf="!isEdit">
                        {{vendor.preferredMethodName}}
                      </td>
                      <td *ngIf="isEdit" class="action">
                          <p-dropdown [options]="vendor.defaultPaymentMethods" optionLabel="name" appendTo="body" optionDisabled="inactive"
                          [(ngModel)]="vendor.preferredMethod" placeholder="Select Preferred" optionValue="id" (onChange)="onChangeCustomRule(vendor)"></p-dropdown>
                      </td>
                  </ng-container>
                  <td class="action">
                    <p-checkbox [binary]="true" [(ngModel)]="vendor.isChecked" disabled></p-checkbox>
                  </td>
              </tr>
          </ng-template>
      </p-table>
  </div>
  <p-footer>
    <button type="button" pButton (click)="cancelDialog()" label="Cancel" class="p-button-secondary"></button>
    <button type="button" pButton (click)="saveBulkVendorCustomRules()" [disabled]="selectedVendors?.length==0 || isDisabled" label="Save"></button>
  </p-footer>
</p-dialog>

<!-- For Accounts -->
<p-dialog [(visible)]="displayAccountTB" [modal]="true" [responsive]="true" [style]="{width: '80vw'}" [closable]="false">
  <div class="card">
      <p-table #dt [value]="accountsData"
       [paginator]="true" [totalRecords]="totalRecords" [lazy]="true" [rows]="pageSize" [showCurrentPageReport]="true"
       currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" (onPage)="getAccountsData($event)"
        [first]=first>
          <ng-template pTemplate="caption">
              <div class="p-d-flex p-jc-between">
                  <div style="width: 30%;">
                      <input pInputText type="text" (ngModelChange)="changed($event,'account')" [(ngModel)]="searchValue" placeholder="Search..." />
                  </div>
              </div>
          </ng-template>
          <ng-template pTemplate="header">
              <tr>
                  <th>Account Name</th>
                  <th>Street</th>
                  <th>City</th>
                  <th>State</th>
                  <th>{{headerType}}</th>
                  <th>Prefered Selected</th>
                  <th class="action" style="width: 2rem;">
                      <span class="btnBars p-mr-0">
                          <i class="pi pi-pencil" (click)="isEdit = !isEdit"></i>
                      </span>
                  </th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-account let-rowIndex="rowIndex">
              <tr>
                  <td>{{account.name}}</td>
                  <td>{{account.street}}</td>
                  <td>{{account.city}}</td>
                  <td>{{account.state}}</td>
                  <ng-container *ngIf="isPaymentTerm">
                      <td *ngIf="!isEdit">
                          <ng-container *ngFor="let s of account.defaultPaymentTerms; let i = index;">
                              <span>{{s.name}}</span>
                              <span *ngIf="account.defaultPaymentTerms.length > 1 && i !== account.defaultPaymentTerms.length-1">,</span>
                          </ng-container>
                      </td>
                      <td *ngIf="isEdit" class="action">
                          <p-multiSelect [options]="account.paymentTerms" [(ngModel)]="account.defaultPaymentTerms" 
                          optionLabel="name" appendTo="body"  placeholder="Select Default" (onChange)="onChangeAccountCustomRule(account)"></p-multiSelect>
                      </td>
                      <td *ngIf="!isEdit">
                            {{account.preferredPaymentName}}
                      </td>
                      <td *ngIf="isEdit" class="action">
                          <p-dropdown [options]="account.defaultPaymentTerms" optionLabel="name" appendTo="body" optionDisabled="inactive"
                          [(ngModel)]="account.preferredPayment" placeholder="Select Preferred" (onChange)="onChangeAccountCustomRule(account)" optionValue="id"></p-dropdown>
                      </td>
                  </ng-container>
                  <ng-container *ngIf="isPaymentMethod">
                      <td *ngIf="!isEdit">
                          <ng-container *ngFor="let s of account.defaultPaymentMethods; let i = index;">
                              <span>{{s.name}}</span>
                              <span *ngIf="account.defaultPaymentMethods.length > 1 && i !== account.defaultPaymentMethods.length-1">,</span>
                          </ng-container>
                      </td>
                      <td *ngIf="isEdit" class="action">
                          <p-multiSelect [options]="account.paymentMethods" [(ngModel)]="account.defaultPaymentMethods" 
                          optionLabel="name" placeholder="Select Default" appendTo="body" (onChange)="onChangeAccountCustomRule(account)"></p-multiSelect>
                      </td>
                      <td *ngIf="!isEdit">
                        {{account.preferredMethodName}}
                      </td>
                      <td *ngIf="isEdit" class="action">
                          <p-dropdown [options]="account.defaultPaymentMethods" optionLabel="name" appendTo="body" optionDisabled="inactive"
                          [(ngModel)]="account.preferredMethod" placeholder="Select Preferred" optionValue="id" (onChange)="onChangeAccountCustomRule(account)"></p-dropdown>
                      </td>
                  </ng-container>
                  <td class="action">
                    <p-checkbox [binary]="true" [(ngModel)]="account.isChecked" disabled></p-checkbox>
                  </td>
              </tr>
          </ng-template>
      </p-table>
  </div>
  <p-footer>
    <button type="button" pButton (click)="cancelDialog()" label="Cancel" class="p-button-secondary"></button>
    <button type="button" pButton (click)="saveBulkAccountCustomRules()" [disabled]="selectedAccounts?.length==0 || isDisabled" label="Save"></button>
  </p-footer>
</p-dialog>

